export const INCREMENT = "item/incriment"
export const DECREMENT = "item/decriment"
export const QINCREMENT = "quantity/incriment"
export const QDECREMENT = "quantity/decriment"
export const CLEANCARTS = "clean-cart"